// Training progress management
const PROGRESS_KEY = 'zenermind_training_progress';

export const TrainingProgress = {
  getProgress() {
    try {
      const progress = localStorage.getItem(PROGRESS_KEY);
      return progress ? JSON.parse(progress) : {
        completedModules: [],
        currentModule: 1,
        lastAccessed: null,
        moduleProgress: {}
      };
    } catch {
      return {
        completedModules: [],
        currentModule: 1,
        lastAccessed: null,
        moduleProgress: {}
      };
    }
  },
  
  saveProgress(progress) {
    try {
      localStorage.setItem(PROGRESS_KEY, JSON.stringify(progress));
    } catch {
      // Storage failed silently
    }
  },
  
  markModuleComplete(moduleId) {
    const progress = this.getProgress();
    
    if (!progress.completedModules.includes(moduleId)) {
      progress.completedModules.push(moduleId);
    }
    
    progress.lastAccessed = new Date().toISOString();
    
    // Auto-advance to next module
    if (moduleId < 5) {
      progress.currentModule = moduleId + 1;
    }
    
    this.saveProgress(progress);
    return progress;
  },
  
  updateModuleProgress(moduleId, data) {
    const progress = this.getProgress();
    
    progress.moduleProgress[moduleId] = {
      ...progress.moduleProgress[moduleId],
      ...data,
      lastViewed: new Date().toISOString()
    };
    
    progress.lastAccessed = new Date().toISOString();
    this.saveProgress(progress);
  },
  
  isModuleComplete(moduleId) {
    const progress = this.getProgress();
    return progress.completedModules.includes(moduleId);
  },
  
  resetProgress() {
    localStorage.removeItem(PROGRESS_KEY);
  },
  
  getCompletionPercentage() {
    const progress = this.getProgress();
    return (progress.completedModules.length / 5) * 100;
  }
};
